// extracted by mini-css-extract-plugin
export default {"text_button":"text_button___uRen8"};